import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import { PublishOpportunityErrorModalProps } from './PublishOpportunityErrorModal.types'
import { PublishOpportunityErrorCode } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'

export function PublishOpportunityErrorModal({
  open,
  handleClose,
  errorCode
}: Readonly<PublishOpportunityErrorModalProps>) {
  const { t } = useTranslation()

  const errorCodesMap: Record<PublishOpportunityErrorCode, string> = {
    'opportunity/publish_invalid_state': t('errorMessage.publishOpportunity.publishInvalidState'),
    'opportunity/publish_invalid_dates': t('errorMessage.publishOpportunity.publishInvalidDates'),
    'opportunity/external': t('errorMessage.publishOpportunity.externalOpportunity')
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <AcknowledgeModal
        result="negative"
        title={t('typography.volunteering.publishOpportunityErrorModal.title')}
        description={(errorCode && errorCodesMap[errorCode]) ?? t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
